"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMajorVersion = exports.snakeToCamelCase = void 0;
var snakeToCamelCase = function (str) { return str.replace(/([-_][a-z])/g, function (group) { return group.toUpperCase()
    .replace('-', '')
    .replace('_', ''); }); };
exports.snakeToCamelCase = snakeToCamelCase;
var getMajorVersion = function (version) {
    if (version !== undefined && version !== null && version.indexOf('.') !== -1) {
        var versionNumber = Number.parseInt(version.split('.')[0]);
        if (!Number.isNaN(versionNumber)) {
            return versionNumber;
        }
    }
    return (-1);
};
exports.getMajorVersion = getMajorVersion;
//# sourceMappingURL=utils.js.map